import React, { useEffect, useState, useRef } from "react";
import "./dmView.scss";
import FormInputWithHeader from "../../../common/FormInputWithHeader";
import deleteIcon from "../../../../assets/delete_icon_pre.svg";
import Highlighter from "react-highlight-words";
import Spinner from "react-bootstrap/Spinner";
import { ClickAwayListener } from "@material-ui/core";
import {
  SAVE_DRUG_IN_DB,
  SAVE_DRUG_INSTRUCTION_IN_DB,
} from "../../ERXViewApiHandler/apiConstants";
import loaderIcon from "../../../../assets/loader_check_206d4a52 (1).gif";
import errorIcon from "../../../../assets/cross-error.svg";
import tick from "../../../../assets/tick1.svg";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import CustomSingleSelect from "../../common/CustomSingleSelect";
import { CUSTOM_BUTTON_STATUS } from "../../ERXConstants/constants";
import CustomSingleSelectWithInput from "../../common/CustomSingleSelectWithInput";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const DMContainer = (props) => {
  const {
    element_id,
    index,
    drugDetails,
    frequencyOptions,
    frequencyDetailsOption,
    durationOptions,
    quantityOptions,
    unitOptions,
    drugOption,
    instructuionOptions,
    prescription_id,
    handleInstructionChange,
    handleDeleteDrug,
    handleDuration,
    handleDrugDetails,
    handleFrequency,
    handleFrequencyInput,
    handleSearchDrug,
    handleDrugSelect,
    handleDeleteDrugOption,
    handleDrugIndx,
    handleKnowledgeBaseDrug,
    onSelect,
    handleInstructionOptions,
    handleKnowledgeBaseInstruction,
    handleQuantity,
    handleUnit,
    handleDurationInput,
    handleOnScrollDropdown,
    handelClickAway,
    drugIndx,
    formRefs,
    setDrugApiFlag,
    drugApiFlag,
  } = props;
  const [showDropdown, setShowDropDown] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [drugInfo, setDrugInfo] = useState({});
  const [isCustomDuration, setIsCustomDuration] = useState(false);
  const [isCustomQuantity, setIsCustomQuantity] = useState(false);
  const [isCustomUnit, setIsCustomUnit] = useState(false);
  const [tempInstruction, setTempInstruction] = useState("");
  const [tempDrugName, setTempDrugName] = useState("");
  const [dropdownPosition, setDropdownPosition] = useState("bottom");

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const dropdownRef = useRef(null);
  const drugNameRef = useRef();

  useEffect(() => {
    if (drugDetails) {
      setDrugInfo(drugDetails);
      let selectedVal = frequencyOptions.find(
        (freq) =>
          freq.value?.trim()?.toLowerCase() ===
          drugDetails?.frequency_extended?.title?.trim()?.toLowerCase()
      );

      if (
        drugDetails?.frequency_extended?.title?.trim()?.toLowerCase() &&
        !selectedVal
      ) {
        setIsCustom(true);
      }

      let selectedDuration = durationOptions.find(
        (duration) =>
          duration.value?.trim()?.toLowerCase() ===
          drugDetails?.duration?.trim()?.toLowerCase()
      );
      if (drugDetails?.duration?.trim()?.toLowerCase() && !selectedDuration) {
        setIsCustomDuration(true);
      }
      let selectedQuantity = quantityOptions.find(
        (quantity) =>
          quantity.value?.trim()?.toLowerCase() ===
          drugDetails?.quantity?.trim()?.toLowerCase()
      );

      if (drugDetails?.quantity?.trim()?.toLowerCase() && !selectedQuantity) {
        setIsCustomQuantity(true);
      }
      let selectedUnit = unitOptions.find(
        (unit) =>
          unit.value?.trim()?.toLowerCase() ===
          drugDetails?.unit?.trim()?.toLowerCase()
      );

      if (drugDetails?.unit?.trim()?.toLowerCase() && !selectedUnit) {
        setIsCustomUnit(true);
      }
    }
  }, [{ ...drugDetails }]);

  useEffect(() => {
    if (drugOption?.length) {
      handleOpenDropdown();
    }
  }, [drugOption]);

  const checkFrequency = (index, value) => {
    if (value?.value?.toLowerCase() === "custom") {
      if (!isCustom) {
        handleFrequencyInput(index, "");
      }
      setIsCustom(true);
    } else {
      setIsCustom(false);
      handleFrequency(index, value);
    }
  };

  const checkDuration = (durationIndex, value) => {
    if (value?.value?.toLowerCase() === "custom") {
      if (!isCustomDuration) {
        handleDurationInput(durationIndex, "");
      }
      setIsCustomDuration(true);
    } else {
      setIsCustomDuration(false);
      handleDuration(durationIndex, value);
    }
  };

  const checkQuantity = (quantityIndex, value) => {
    if (value?.value?.toLowerCase() === "custom") {
      if (!isCustomQuantity) {
        handleQuantity(quantityIndex, "");
      }
      setIsCustomQuantity(true);
    } else {
      setIsCustomQuantity(false);
      handleQuantity(quantityIndex, value?.value);
    }
  };

  const checkUnit = (unitIndex, value) => {
    if (value?.value?.toLowerCase() === "custom") {
      if (!isCustomUnit) {
        handleUnit(unitIndex, "");
      }
      setIsCustomUnit(true);
    } else {
      setIsCustomUnit(false);
      handleUnit(unitIndex, value?.value);
    }
  };

  const handleOpenDropdown = () => {
    if (!drugNameRef.current || !dropdownRef.current) return;

    const inputRect = drugNameRef.current.getBoundingClientRect();
    const dropdownRect = dropdownRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - inputRect.bottom;
    const spaceAbove = inputRect.top;
    const dropdownHeight = dropdownRect.height;
    let position = "bottom";
    if (dropdownHeight > spaceBelow && spaceBelow < spaceAbove) {
      position = "top";
    }
    setDropdownPosition(position);

    if (tempDrugName) setShowDropDown(true);
    else {
      setShowDropDown(false);
    }
  };

  const handleKeyboardNavigation = (event, fieldIndex, isInput) => {
    if (!isInput) return;
    if (event.key === "Enter") {
      event.preventDefault();
      openNextDropdown(fieldIndex);
    }
  };

  const openNextDropdown = (fieldIndex, option) => {
    if (option && option.value === "Custom") return;
    const currField = formRefs.current?.[index]?.[fieldIndex]?.current;
    const nextField = formRefs.current?.[index]?.[fieldIndex + 1]?.current;

    if (currField?.closeDropdown) {
      currField.closeDropdown();
    }
    if (drugNameRef?.current && fieldIndex === 0) {
      setShowDropDown(false);
      drugNameRef.current.blur();
    }

    if (!nextField) {
      return;
    }

    if (nextField?.openDropdown) {
      setTimeout(() => {
        nextField.openDropdown();
        if (nextField?.doFocus) nextField.doFocus();
      }, 100);
    } else {
      nextField.focus();
    }
  };

  const handleQuantityInput = (quantityInputIndex, value) => {
    let regEx = /^[0-9/. ]+$/;
    if (value?.length > 0) {
      if (regEx.test(value)) {
        handleQuantity(quantityInputIndex, value);
      }
    } else {
      handleQuantity(quantityInputIndex, "");
    }
  };

  const handleSaveDrug = (drug) => {
    let reqPayload = {
      drug_id: drug?.id,
      drug: drug?.drug?.trim(),
      doctor_id: userId,
    };
    const saveDrugResponse = c2cPostApiHandler(SAVE_DRUG_IN_DB, reqPayload); //Fetch API Data
    saveDrugResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setDrugInfo({
            ...drug,
            drug_button_status: CUSTOM_BUTTON_STATUS.LOADING,
          });
          let data = { ...res?.data?.data };
          data["drug_button_status"] = CUSTOM_BUTTON_STATUS.LOADING;
          data["drug_id"] = drug?.id;
          setTimeout(() => {
            setDrugInfo({
              ...drug,
              drug_button_status: CUSTOM_BUTTON_STATUS.SUCCESS,
            });
            data["drug_button_status"] = CUSTOM_BUTTON_STATUS.SUCCESS;
          }, 2000);
          handleKnowledgeBaseDrug(data);
        } else {
          triggerErrorLoader(drug);
        }
      } else {
        triggerErrorLoader();
      }
    });
  };

  const triggerErrorLoader = (drug) => {
    setDrugInfo({
      ...drug,
      drug_button_status: CUSTOM_BUTTON_STATUS.ERROR,
    });
    setTimeout(() => {
      setDrugInfo({
        ...drug,
        drug_button_status: CUSTOM_BUTTON_STATUS.SAVE,
      });
    }, 2000);
  };

  const handleSaveCustomInstruction = (drug) => {
    let requestPayload = {
      "authorizer-principal-id": { user_type: "1" },
      prescription_id: prescription_id,
      doctor_id: userId,
      title: drug?.instructions?.trim(),
    };
    const saveInstructionResponse = c2cPostApiHandler(
      SAVE_DRUG_INSTRUCTION_IN_DB,
      requestPayload
    ); //Fetch API Data
    saveInstructionResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setDrugInfo({
            ...drug,
            instruction_button_status: CUSTOM_BUTTON_STATUS.LOADING,
          });
          let data = { ...res?.data };
          data["instruction_button_status"] = CUSTOM_BUTTON_STATUS.LOADING;
          data["drug_id"] = drug?.id;
          setTimeout(() => {
            setDrugInfo({
              ...drug,
              instruction_button_status: CUSTOM_BUTTON_STATUS.SUCCESS,
            });
            data["instruction_button_status"] = CUSTOM_BUTTON_STATUS.SUCCESS;
            handleKnowledgeBaseInstruction(data);
          }, 2000);
        } else {
          triggerInstructionErrorLoader(drug);
        }
      } else {
        triggerInstructionErrorLoader(drug);
      }
    });
  };

  const triggerInstructionErrorLoader = (drug) => {
    setDrugInfo({
      ...drug,
      instruction_button_status: CUSTOM_BUTTON_STATUS.ERROR,
    });
    setTimeout(() => {
      setDrugInfo({
        ...drug,
        instruction_button_status: CUSTOM_BUTTON_STATUS.SAVE,
      });
    }, 2000);
  };

  const renderDrugSuggestionInput = () => {
    return (
      <ClickAwayListener
        key={index}
        onClickAway={() => {
          setDrugApiFlag(false);
          handelClickAway();
          setShowDropDown(false);
        }}
      >
        <div
          style={{ position: "relative", width: "-webkit-fill-available" }}
          className="dmcb-drug-dropdown"
        >
          <div>
            <div
              className="drug-name-input d-flex"
              onClick={(e) => {
                handleDrugIndx(index);
              }}
              onKeyDown={(e) => {
                handleKeyboardNavigation(e, 0, true);
              }}
            >
              <input
                id={element_id}
                value={
                  tempDrugName
                    ? tempDrugName
                    : `${
                        drugInfo?.drug?.trim()?.length > 0 &&
                        drugInfo?.short_name
                          ? drugInfo?.short_name + " "
                          : ""
                      }${drugInfo?.drug}`
                }
                placeholder={"Drug " + (index + 1)}
                onChange={(e) => {
                  !drugApiFlag && setDrugApiFlag(true);
                  setTempDrugName(e.target.value);
                  handleSearchDrug(index, e.target.value, "search");
                }}
                autoComplete="off"
                ref={(el) => {
                  if (formRefs.current) {
                    formRefs.current[index] = formRefs.current[index] || [];
                    formRefs.current[index][0] = el;
                  }
                  drugNameRef.current = el;
                }}
              />
              <span style={{ width: "20px", height: "20px" }}>
                {loader && (
                  <Spinner animation="border" className="spinner_css" />
                )}
              </span>
              {drugInfo?.drug_button_status === CUSTOM_BUTTON_STATUS.SAVE && (
                <span
                  className="dm-save-btn"
                  onClick={() => {
                    setShowDropDown(false);
                    handleSaveDrug(drugInfo);
                  }}
                >
                  Save
                </span>
              )}
              {drugInfo?.drug_button_status ===
                CUSTOM_BUTTON_STATUS.SUCCESS && (
                <img
                  src={tick}
                  alt=""
                  width={19}
                  height={15}
                  style={{ marginRight: "2px" }}
                />
              )}
              {drugInfo?.drug_button_status ===
                CUSTOM_BUTTON_STATUS.LOADING && (
                <img src={loaderIcon} alt="" width={20} height={15} />
              )}
              {drugInfo?.drug_button_status === CUSTOM_BUTTON_STATUS.ERROR && (
                <img src={errorIcon} alt="" width={20} height={15} />
              )}
            </div>

            <div
              className={`drug-list-container ${
                dropdownPosition === "top"
                  ? "dmc-ddui-dropdown-up"
                  : "dmc-ddui-dropdown-down"
              } ${
                showDropdown && index === drugIndx && drugOption?.length > 0
                  ? ""
                  : "dmc-ddui-display-hidden"
              }`}
              onScroll={handleOnScrollDropdown}
              ref={dropdownRef}
            >
              {drugOption.map((item, ind) => (
                <div
                  className="menu-list-option"
                  key={ind}
                  onClick={() => {
                    drugNameRef.current.focus();
                    setTempDrugName(
                      `${item?.short_name ? item?.short_name : ""}${
                        item?.drug_name
                      }`
                    );
                    handleDrugSelect(index, item);
                    setShowDropDown(false);
                    openNextDropdown(0);
                  }}
                >
                  <div>
                    <p className="dmc-ddui-option-title">
                      <span>{item?.short_name}</span>
                      <Highlighter
                        highlightClassName="dmc-ddui-option-title-highlight"
                        searchWords={drugInfo?.drug?.trim().split(" ") ?? []}
                        autoEscape={true}
                        textToHighlight={item?.label}
                      />
                    </p>
                    {(item?.packaging || item?.salt_composition) && (
                      <p className="dmc-ddui-option-sub-title">
                        {item?.packaging}
                        <span className="dmc-ddui-circle"></span>
                        <span className="dmc-ddui-salt-composition">
                          {" "}
                          {item?.salt_composition}
                        </span>
                      </p>
                    )}
                  </div>
                  {item?.drug_id && !item?.drug_master_id && (
                    <div className="ml-auto drug-delete-icon">
                      <i
                        className="fa fa-trash cursor-pointer"
                        onClick={(e) => handleDeleteDrugOption(e, item)}
                        aria-hidden="true"
                      ></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </ClickAwayListener>
    );
  };

  const renderDeletedBtn = () => {
    return (
      <div className="dmc-delete">
        <img
          className="dmc-delete-icon"
          src={deleteIcon}
          alt="x"
          onClick={() => handleDeleteDrug(index)}
        />
      </div>
    );
  };

  return (
    <div className="dm-container">
      <div className="dm-container-header">
        <div className="dmch-drug-title">{`Drug ${index + 1} Name`}</div>

        <div className="dmch-delete-icon">{renderDeletedBtn()}</div>
      </div>
      <div className="dm-container-body">
        <div className={"dmcb-drug-input-ui"}>
          {renderDrugSuggestionInput()}
        </div>

        <div
          className="dmcb-frequency-ui"
          onKeyDown={(e) => {
            handleKeyboardNavigation(e, 1, isCustom);
          }}
        >
          <CustomSingleSelectWithInput
            title={"Frequency"}
            placeholder="Select Frequency"
            value={drugInfo?.frequency_extended?.title}
            maxLimit={20}
            isCustom={isCustom}
            options={frequencyOptions}
            selectedOption={drugInfo?.frequency_extended?.title}
            handleOnChangeInput={(e) => {
              handleFrequencyInput(index, e.target.value);
            }}
            ref={formRefs.current[index][1]}
            handleSelect={(option) => {
              checkFrequency(index, option);
              openNextDropdown(1, option);
            }}
          />
        </div>
        <div className="dmcb-timing-ui">
          <FormInputWithHeader
            title="Timing"
            inputType="dropdown"
            placeholder="Select Timing"
            value={drugInfo?.frequency_extended?.details}
            options={frequencyDetailsOption}
            selectedOption={drugInfo?.frequency_extended?.details}
            handleOnChangeInput={(option) => {
              handleDrugDetails(index, option);
              openNextDropdown(2, option);
            }}
            ref={formRefs.current[index][2]}
          />
        </div>
        <div
          className="dmcb-duration-ui"
          onKeyDown={(e) => {
            handleKeyboardNavigation(e, 3, isCustomDuration);
          }}
        >
          <CustomSingleSelectWithInput
            title={"Duration"}
            value={drugInfo?.duration}
            placeholder="Select Duration"
            type={"text"}
            maxLimit={10}
            isCustom={isCustomDuration}
            options={durationOptions}
            selectedOption={drugInfo?.duration}
            handleOnChangeInput={(e) => {
              handleDurationInput(index, e.target.value);
            }}
            ref={formRefs.current[index][3]}
            handleSelect={(option) => {
              checkDuration(index, option);
              openNextDropdown(3, option);
            }}
          />
        </div>
        <div
          className="dmcb-quantity-ui"
          onKeyDown={(e) => {
            handleKeyboardNavigation(e, 4, isCustomQuantity);
          }}
        >
          <CustomSingleSelectWithInput
            title={"Quantity"}
            value={drugInfo?.quantity}
            placeholder={"Select Quantity"}
            type={"text"}
            maxLimit={7}
            isCustom={isCustomQuantity}
            options={quantityOptions}
            selectedOption={drugInfo?.quantity}
            handleOnChangeInput={(e) => {
              handleQuantityInput(index, e.target.value);
            }}
            handleSelect={(option) => {
              checkQuantity(index, option);
              openNextDropdown(4, option);
            }}
            ref={formRefs.current[index][4]}
          />
        </div>
        <div
          className="dmcb-unit-ui"
          onKeyDown={(e) => {
            handleKeyboardNavigation(e, 5, isCustomUnit);
          }}
        >
          <CustomSingleSelectWithInput
            title={"Unit"}
            value={drugInfo?.unit}
            placeholder={"Select Unit"}
            type={"text"}
            maxLimit={10}
            isCustom={isCustomUnit}
            options={unitOptions}
            selectedOption={drugInfo?.unit}
            handleOnChangeInput={(e) => {
              handleUnit(index, e.target.value);
            }}
            handleSelect={(option) => {
              checkUnit(index, option);
              openNextDropdown(5, option);
            }}
            ref={formRefs.current[index][5]}
          />
        </div>
        <div
          className="dmcb-instruction-ui"
          onKeyDown={(e) => {
            handleKeyboardNavigation(e, 6);
          }}
        >
          <CustomSingleSelect
            title="Instruction"
            type="textarea"
            maxLimit={"250"}
            placeholder={"Instructions"}
            value={tempInstruction ? tempInstruction : drugInfo?.instructions}
            options={drugIndx === index ? instructuionOptions : []}
            button_status={drugInfo?.instruction_button_status}
            handleOnChangeInput={(e) => {
              handleInstructionChange(index, e.target.value);
              setTempInstruction(e.target.value); // TODO: HACK for 29998, need to be corrected in future
              handleDrugIndx(index);
            }}
            handleCloseDropdown={handleInstructionOptions}
            handleSelect={(item) => {
              setTempInstruction(item?.title);
              onSelect(index, item);
            }}
            ref={formRefs.current[index][6]}
            handleSaveCustomData={() => handleSaveCustomInstruction(drugInfo)}
          />
        </div>
      </div>
    </div>
  );
};

export default DMContainer;
